<div class="text-align-center max-300">
  <h3 class="t-3@r color-white mb-2">Photo Privacy</h3>
  <div class="t-8@r color-white mb-4">For privacy, message photos can only be viewed once before they vanish.</div>
  <button sbButton type="button" [size]="'big'" [variant]="'fill-green'" (click)="close()">Got it</button>
</div>
